import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { DisabledReasonPopOver, HorizontalStack, Icon } from '@ztechapps/webui.util'
import { NO_VIEW_PERMISSION_REASON } from '../PermissionReasons'
import { useWhatsNewContext } from './Context'

/** The profile menu's What's New entry: disabled with its reason without blog.canView; with it, absent until there is a post. */
export const WhatsNewDropdownItem = () => {
  const { post, canView, openWhatsNew } = useWhatsNewContext()

  if (canView && !post) return null

  return (
    <DisabledReasonPopOver reason={canView ? undefined : NO_VIEW_PERMISSION_REASON}>
      <Dropdown.Item onClick={openWhatsNew} disabled={!canView}>
        <HorizontalStack gap={1}>
          <Icon name="gift" aria-hidden="true" />
          <span>What&apos;s New</span>
        </HorizontalStack>
      </Dropdown.Item>
    </DisabledReasonPopOver>
  )
}
